import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { AvatarComponent, ButtonComponent, IconComponent, TooltipDirective } from '@mode/capra';
import { AlertBannerComponent, SharedUiModule } from '@mode/shared/ui';

import { AccessorNameComponent } from './accessor-name/accessor-name.component';
import { AddAccessDialogComponent } from './add-access-dialog/add-access-dialog.component';
import { CollectionManageAccessModalService } from './collection-manage-access-modal.service';
import { ManageAccessDialogComponent } from './manage-access-dialog/manage-access-dialog.component';
import { AccessorSearchComponent } from './accessor-search/accessor-search.component';
import { AccessorSearchInputComponent } from './accessor-search/accessor-search-input/accessor-search-input.component';
import { GroupAvatarComponent } from './group-avatar/group-avatar.component';
import { AccessSelectorComponent } from './access-selector/access-selector.component';
import { AccessInlineToastComponent } from './access-inline-toast/access-inline-toast.component';
import { WorkspaceAccessSelectorComponent } from './workspace-access-selector/workspace-access-selector.component';
import { AccessDialogsContainerComponent } from './access-dialogs-container/access-dialogs-container.component';
import { DefaultAccessInlineToastComponent } from './default-access-inline-toast/default-access-inline-toast.component';
import { InlineToastComponent } from './inline-toast/inline-toast.component';

@NgModule({
  imports: [
    AlertBannerComponent,
    AvatarComponent,
    ButtonComponent,
    CommonModule,
    IconComponent,
    MatLegacyButtonModule,
    MatLegacyDialogModule,
    MatLegacyListModule,
    MatLegacyMenuModule,
    SharedUiModule,
    TooltipDirective,
  ],
  declarations: [
    AccessSelectorComponent,
    AccessorNameComponent,
    AddAccessDialogComponent,
    ManageAccessDialogComponent,
    AccessDialogsContainerComponent,
    AccessorSearchComponent,
    AccessorSearchInputComponent,
    GroupAvatarComponent,
    AccessInlineToastComponent,
    WorkspaceAccessSelectorComponent,
    DefaultAccessInlineToastComponent,
    InlineToastComponent,
  ],
  providers: [{ provide: Window, useValue: window }, CollectionManageAccessModalService],
})
export class CollectionsFeatureManageAccessModule {}
